import React from 'react';
import PropTypes from 'prop-types';
import ValidatableField from './ValidatableField';


import './CheckBox.css';

class CheckBox extends ValidatableField {
  constructor(props) {
    super(props);
    this.state = { value: props.value };
    this.onToggle = this.onToggle.bind(this);
  }

  static get propTypes() {
    return {
      label: PropTypes.string.isRequired,
      value: PropTypes.bool,
      editing: PropTypes.bool,
      className: PropTypes.string,
      onChange: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      onChange: () => {},
    };
  }
  componentWillReceiveProps(props) {
    if (this.state.value !== props.value) {
      this.setState({ value: props.value }, () => this.validate());
    }
  }

  validate() {
    this.setValid(true);
    return true;
  }
  onToggle() {
    const { onChange } = this.props;
    const value = !this.state.value;
    this.setState({ value });
    onChange(value);
  }

  renderControl() {
    const { value } = this.state;
    const { editing } = this.props;
    return (
      <span className="CheckBox-container">
        {!editing && <span>{value === true ? 'Yes' : 'No'} </span>}
        {editing && <span><input type="checkbox" checked={value} onClick={this.onToggle} /></span>}
      </span>
    );
  }
}

export default CheckBox;



// WEBPACK FOOTER //
// ./src/recordDetail/fields/CheckBox.js